import { Slider } from "@mantine/core";

export const SliderPropertyField = (props: {
  value: number;
  min: number;
  max: number;
  step: number;
  onChange: (value: string | null) => void;
}) => {
  const { value, min, max, step, onChange } = props;
  // const min = property.getMin();
  // const max = property.getMax();
  // const step = property.getStep();
  // const defaultValue = property.getDefaultValue();
  // const value = property.getValue();

  return (
    <Slider
      size="xs"
      value={value}
      onChange={(value) => {
        if (value == null) return;
        onChange("" + value);
      }}
      // label={(value) => `${value}%`}
      min={min}
      max={max}
      step={step}
      // marks={[
      //   { value: 20, label: '20%' },
      //   { value: 50, label: '50%' },
      //   { value: 80, label: '80%' },
      // ]}
    />
  );
};
